<script lang="ts" setup>
import BrandActive from './components/BrandActive.vue'
import BrandSlide from './components/BrandSlide.vue'
import { useArticleStore, useGlobalStore } from '@/stores'
import useSeo from './seo'
const route = useRoute()

// get data
const queryBrandId = route.params.brandId
const articleStore = useArticleStore()
const brand = await articleStore.fetchArticleBrand(queryBrandId as string)

useSeo(brand)
</script>

<template>
  <div class="brand">
    <div class="brand__top">
      <figure class="brand__logo">
        <Nimg :src="brand?.logo?.link" :alt="brand?.logo?.alt" :title="brand?.logo?.title" format="webp" />
      </figure>
      <h1 class="brand__title">{{ brand?.description }}</h1>
    </div>
    <figure class="brand__banner">
      <Nimg :src="brand?.image?.link" :alt="brand?.logo?.alt" :title="brand?.logo?.title" format="webp" />
    </figure>
    <div class="brand__bottom">
      <Block :blocks="brand?.blocks" />
      <BrandSlide :products="brand?.products" :url="brand?.url" />
    </div>
  </div>
  <BrandActive :events="brand.events" v-if="brand.events.length > 0" />
</template>

<style lang="scss" scoped>
.brand {
  &__top {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: toRem(120);
    padding-top: toRem(50);

    @include max-media(1280) {
      margin-bottom: toRem(50);
      padding-top: toRem(20);
    }

    @include max-media(767) {
      margin-bottom: toRem(30);
    }
  }

  &__logo {
    margin-bottom: toRem(10);

    img {
      display: block;
      max-width: toRem(210);
    }
  }

  &__title {
    font-size: toRem(28);
    font-weight: 500;
    text-align: center;
    display: table-cell;
    vertical-align: middle;

    @include max-media(767) {
      font-size: toRem(24);
    }
  }

  &__banner {
    margin-bottom: toRem(140);

    @include max-media(1280) {
      margin-bottom: toRem(70);
    }

    @include max-media(767) {
      margin-bottom: toRem(50);
    }

    img {
      display: block;
      width: 100%;
    }
  }

  &__bottom {
    width: 100%;
    max-width: toRem(920);
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
